<ion-card
  [class]="starColor ? 'ion-card-' + starColor : ''"
  title="{{ 'ratings.ratings-item.details' | translate }}"
  button="true"
  detail="false"
  *ngIf="currentReview"
  (click)="onReviewClick()"
>
  <ion-item lines="none">
    <ion-label class="ion-text-wrap ion-no-margin">
      <p *ngIf="currentReview.order_id">
        <strong
          >{{ "orders.order" | translate }} #{{
            currentReview.order_id
          }}</strong
        >
      </p>
      <p *ngIf="currentReview.timestamp">
        <strong>{{
          currentReview.timestamp | date : "dd/MM/yyyy HH:mm"
        }}</strong>
      </p>
      <ion-badge color="complete" *ngIf="currentReview.storeAnswer">
        {{ "ratings.ratings-item.store-has-answered-your-review" | translate }}
      </ion-badge>

      <div
        *ngIf="reviewStarAverage || reviewStarAverage === 0"
        class="rating-item__summary"
      >
        <div class="rating-item__avg">
          {{ reviewStarAverage }}
        </div>
        <div class="rating-item__stars">
          <ion-icon
            *ngFor="let icon of starIcons"
            [name]="icon"
            [color]="starColor"
            class="rating-item__icon"
          ></ion-icon>
        </div>
      </div>
      <ion-text
        color="medium"
        class="rating-item__count"
        *ngIf="ratingQuestionsCount"
      >
        {{ "ratings.modals.rating-details.based-on" | translate }}
        {{ ratingQuestionsCount }}
        {{ "ratings.modals.rating-details.questions" | translate }}
      </ion-text>
    </ion-label>

    <ion-icon
      size="small"
      slot="end"
      src="assets/ionicons/chevron-forward.svg"
    ></ion-icon>
  </ion-item>
</ion-card>
